/* ==========================================================================
   SEASONS — Build Your Own bundle builder
   assets/bundle-builder.js

   HOW THE DISCOUNT IS GATED
   -------------------------
   The 10% is a discount CODE, not an automatic discount, so it can only ever
   be applied by something that knows the code. The only thing that knows it
   is this file, and it only uses it after a qualifying bundle has been added.
   A customer who assembles the same cart by browsing the site never gets it.

   Flow on "Add bundle to cart":
     1. POST /cart/add.js with every chosen variant, each line tagged with the
        hidden property _bundle = true. (Properties beginning with "_" are
        hidden from the customer but ARE visible on the order in admin, so you
        can report on which orders came through the builder.)
     2. Redirect to /discount/<CODE>?redirect=/cart, which applies the code to
        the cart and lands the customer on the cart page with it showing.

   The _bundle property does double duty: free-gift.js watches for it and
   withholds the free power adapter on bundle carts, because the adapter's
   Buy X Get Y discount and this code can't both land on the diffuser line.

   WHAT THIS FILE DOES NOT DO
   --------------------------
   It does not enforce the rule after the fact. Once the code is on the cart
   it stays there; Shopify re-checks the code's own restrictions at checkout
   (collection + minimum quantity), which are looser than the rule here.
   ========================================================================== */

(function () {
  'use strict';

  var CFG = window.SEASONS_BYO;
  if (!CFG || !CFG.products || !CFG.products.length) return;

  var root = document.querySelector('[data-byo]');
  if (!root) return;

  var state = {
    diffuser: null,
    oils: {},
    // Remembers the colour chosen per diffuser, so a card keeps showing the
    // one the customer picked even after they look at another diffuser.
    variantByProduct: {}
  };

  var byVariant = {};
  var diffusers = [];
  var oils = [];

  CFG.products.forEach(function (p) {
    (p.group === 'oil' ? oils : diffusers).push(p);
    p.variants.forEach(function (v) {
      byVariant[String(v.id)] = { product: p, variant: v };
    });
  });

  function money(cents) {
    if (window.KROWN && KROWN.helpers && KROWN.helpers.formatMoney) {
      // Split's helper needs the format string as a second argument.
      return KROWN.helpers.formatMoney(cents, KROWN.settings && KROWN.settings.shop_money_format);
    }
    return '$' + (cents / 100).toFixed(2);
  }

  function words(n) {
    return ['zero', 'one', 'two', 'three', 'four', 'five', 'six'][n] || String(n);
  }

  function oilCount() {
    var n = 0;
    Object.keys(state.oils).forEach(function (k) { n += state.oils[k]; });
    return n;
  }

  function qs(sel) { return root.querySelector(sel); }
  function qsa(sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); }

  function selectDiffuser(productId) {
    var product = null;
    diffusers.forEach(function (p) { if (String(p.id) === String(productId)) product = p; });
    if (!product) return;

    if (state.diffuser && String(state.diffuser.productId) === String(productId)) {
      state.diffuser = null;
    } else {
      var remembered = state.variantByProduct[String(product.id)];
      var pick = null;
      if (remembered) {
        product.variants.forEach(function (v) {
          if (String(v.id) === String(remembered) && v.available) pick = v;
        });
      }
      if (!pick) product.variants.forEach(function (v) { if (!pick && v.available) pick = v; });
      if (!pick) return;
      state.variantByProduct[String(product.id)] = pick.id;
      state.diffuser = { productId: product.id, variantId: pick.id };
    }
    render();
  }

  function selectVariant(variantId) {
    var hit = byVariant[String(variantId)];
    if (!hit || !hit.variant.available) return;
    state.variantByProduct[String(hit.product.id)] = hit.variant.id;
    // Clicking a colour also selects that diffuser — one click, not two.
    state.diffuser = { productId: hit.product.id, variantId: hit.variant.id };
    render();
  }

  function bumpOil(variantId, delta) {
    var key = String(variantId);
    var next = (state.oils[key] || 0) + delta;
    if (next <= 0) { delete state.oils[key]; } else { state.oils[key] = next; }
    render();
  }

  function render() {
    var count = oilCount();
    var hasDiffuser = !!state.diffuser;
    var oilsOk = count >= CFG.minOils;
    var ready = hasDiffuser && oilsOk;

    qsa('[data-byo-diffuser]').forEach(function (el) {
      var on = hasDiffuser && String(state.diffuser.productId) === el.getAttribute('data-byo-diffuser');
      el.classList.toggle('is-selected', on);
      el.setAttribute('aria-pressed', on ? 'true' : 'false');
    });

    // Each diffuser card owns its colour row. Mark the chosen swatch and keep
    // the card image in step with it — variants have their own photography.
    qsa('[data-byo-variant]').forEach(function (el) {
      var pid = el.getAttribute('data-byo-variant-of');
      var vid = el.getAttribute('data-byo-variant');
      var on = String(state.variantByProduct[String(pid)] || '') === String(vid);
      el.classList.toggle('is-selected', on);
      el.setAttribute('aria-pressed', on ? 'true' : 'false');
    });

    qsa('[data-byo-card-img]').forEach(function (img) {
      var card = img.closest('[data-byo-diffuser]');
      if (!card) return;
      var pid = card.getAttribute('data-byo-diffuser');
      var vid = state.variantByProduct[String(pid)];
      var src = img.getAttribute('data-byo-default-img') || img.getAttribute('src');
      if (vid && byVariant[String(vid)] && byVariant[String(vid)].variant.image) {
        src = byVariant[String(vid)].variant.image;
      }
      if (img.getAttribute('src') !== src) img.setAttribute('src', src);
    });

    // Oil cards
    qsa('[data-byo-oil]').forEach(function (el) {
      var vid = el.getAttribute('data-byo-oil');
      var q = state.oils[vid] || 0;
      el.classList.toggle('is-selected', q > 0);
      el.querySelector('[data-byo-qty]').textContent = q;
      el.querySelector('[data-byo-minus]').disabled = q <= 0;
    });

    var dStatus = qs('[data-byo-diffuser-status]');
    if (dStatus) {
      var chosen = hasDiffuser ? byVariant[String(state.diffuser.variantId)] : null;
      dStatus.textContent = chosen ? chosen.product.title : 'Required';
      dStatus.classList.toggle('is-met', hasDiffuser);
    }

    var oStatus = qs('[data-byo-oil-status]');
    if (oStatus) {
      oStatus.textContent = count + (count === 1 ? ' oil added' : ' oils added');
      oStatus.classList.toggle('is-met', oilsOk);
    }

    var fill = qs('[data-byo-fill]');
    if (fill) fill.style.width = Math.min(100, Math.round((count / CFG.minOils) * 100)) + '%';

    var r1 = qs('[data-byo-req-diffuser]');
    if (r1) r1.classList.toggle('is-met', hasDiffuser);
    var r2 = qs('[data-byo-req-oils]');
    if (r2) r2.classList.toggle('is-met', oilsOk);

    var lines = [];
    var subtotal = 0;

    if (hasDiffuser) {
      var d = byVariant[String(state.diffuser.variantId)];
      if (d) {
        subtotal += d.variant.price;
        lines.push({
          title: d.product.title,
          meta: d.product.variants.length > 1 ? d.variant.title : '',
          qty: 1,
          amount: d.variant.price,
          img: d.variant.thumb || d.product.image
        });
      }
    }

    oils.forEach(function (p) {
      p.variants.forEach(function (v) {
        var q = state.oils[String(v.id)] || 0;
        if (!q) return;
        subtotal += v.price * q;
        lines.push({ title: p.title, meta: '', qty: q, amount: v.price * q, img: p.image });
      });
    });

    var listEl = qs('[data-byo-lines]');
    listEl.innerHTML = '';
    lines.forEach(function (l) {
      var row = document.createElement('div');
      row.className = 'byo-line';
      var img = document.createElement('img');
      img.className = 'byo-line__img';
      img.src = l.img || '';
      img.alt = '';
      img.loading = 'lazy';
      var body = document.createElement('div');
      body.className = 'byo-line__body';
      var t = document.createElement('div');
      t.className = 'byo-line__title';
      t.textContent = l.title;
      var m = document.createElement('div');
      m.className = 'byo-line__meta';
      m.textContent = (l.meta ? l.meta + ' · ' : '') + 'Qty ' + l.qty;
      var amt = document.createElement('div');
      amt.className = 'byo-line__amt';
      amt.textContent = money(l.amount);
      body.appendChild(t);
      body.appendChild(m);
      row.appendChild(img);
      row.appendChild(body);
      row.appendChild(amt);
      listEl.appendChild(row);
    });

    qs('[data-byo-empty]').style.display = lines.length ? 'none' : '';

    // Match Shopify's arithmetic exactly. It allocates the percentage to each
    // line and floors to the cent, so a $18.99 oil gives $1.89, not $1.90.
    // Rounding the cart total instead drifts a couple of cents away from what
    // checkout actually charges, which looks like a bug to the customer.
    var discount = 0;
    if (ready) {
      lines.forEach(function (l) {
        discount += Math.floor(l.amount * (CFG.discountPct / 100));
      });
    }

    qs('[data-byo-subtotal]').textContent = money(subtotal);
    qs('[data-byo-discount]').textContent = '-' + money(discount);
    qs('[data-byo-discount-row]').classList.toggle('is-on', ready);
    qs('[data-byo-total]').textContent = money(subtotal - discount);

    // The free power adapter is withheld on bundle carts (see free-gift.js).
    // Only say so when the chosen diffuser is one that would have triggered it.
    var note = qs('[data-byo-gift-note]');
    if (note) {
      var triggerIds = (CFG.giftTriggerIds || []).map(String);
      var swaps = hasDiffuser && triggerIds.indexOf(String(state.diffuser.productId)) !== -1;
      note.classList.toggle('is-on', !!swaps);
    }

    var cta = qs('[data-byo-cta]');
    cta.disabled = !ready;
    if (!cta.classList.contains('is-loading')) {
      if (!hasDiffuser) {
        cta.textContent = 'Choose a diffuser';
      } else if (!oilsOk) {
        var short = CFG.minOils - count;
        cta.textContent = 'Add ' + words(short) + (short === 1 ? ' more oil' : ' more oils');
      } else {
        cta.textContent = CFG.ctaLabel || 'Add bundle to cart';
      }
    }
  }

  function addBundle() {
    var cta = qs('[data-byo-cta]');
    var err = qs('[data-byo-error]');
    err.classList.remove('is-on');

    var items = [];

    if (state.diffuser) {
      items.push({
        id: parseInt(state.diffuser.variantId, 10),
        quantity: 1,
        properties: { _bundle: 'true' }
      });
    }

    Object.keys(state.oils).forEach(function (vid) {
      items.push({
        id: parseInt(vid, 10),
        quantity: state.oils[vid],
        properties: { _bundle: 'true' }
      });
    });

    if (!items.length) return;

    cta.disabled = true;
    cta.classList.add('is-loading');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (body) { throw new Error(body.description || body.message || 'Could not add to cart'); });
        return r.json();
      })
      .then(function () {
        window.location.href = '/discount/' + encodeURIComponent(CFG.discountCode) + '?redirect=/cart';
      })
      .catch(function (e) {
        cta.classList.remove('is-loading');
        cta.disabled = false;
        err.textContent = e.message || 'Something went wrong. Please try again.';
        err.classList.add('is-on');
        render();
      });
  }

  root.addEventListener('click', function (e) {
    var swatch = e.target.closest('[data-byo-variant]');
    if (swatch) {
      selectVariant(swatch.getAttribute('data-byo-variant'));
      return;
    }

    var card = e.target.closest('[data-byo-diffuser]');
    if (card && !card.classList.contains('is-soldout')) {
      selectDiffuser(card.getAttribute('data-byo-diffuser'));
      return;
    }

    var plus = e.target.closest('[data-byo-plus]');
    if (plus) {
      bumpOil(plus.getAttribute('data-byo-plus'), 1);
      return;
    }

    var minus = e.target.closest('[data-byo-minus]');
    if (minus) {
      bumpOil(minus.getAttribute('data-byo-minus'), -1);
      return;
    }

    if (e.target.closest('[data-byo-cta]')) {
      addBundle();
    }
  });

  render();

  window.SeasonsBundleBuilder = { state: state, render: render, config: CFG };
})();
